(function() {
	'use strict';
	
	var spans = [
		{ max: 7, unit: 'days', label: 'Updated this week' },
		{ max: 30, unit: 'days', label: 'Updated last 30 days' },
		{ max: 60, unit: 'days', label: 'Updated last 60 days' },
		{ max: 90, unit: 'days', label: 'Updated last 90 days' },
		{ max: 1, unit: 'year', label: 'Updated over 3 months ago' }
	];
	spans.forEach(function(span) {
		span.duration = moment.duration(span.max, span.unit);
	});

	angular.module('app.core').filter('relativeHeadingTime', function() {
		var now = new moment();
		return function(input) {
			var m = moment(input),
				duration = moment.duration(now.diff(m));
			for (var i = 0; i < spans.length; i++) {
				if (spans[i].duration >= duration) {
					return spans[i].label;
				}
			}
			return 'Updated over ' + duration.humanize() + ' ago';
		};
	});
})();;
